import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from "@headlessui/react";
import { ArrowUpTrayIcon } from "@heroicons/react/24/solid";
import { ButtonBase, ButtonDummy, FileInputBase } from "../index";
import { FormProvider, useForm } from "react-hook-form";
import { Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { fileUtility } from "@repo/utilities/file.utility.ts";
interface IUInputMenuProps {
  text?: string;
  heading?: string;
  className?: string;
  isLoading: boolean;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (data: { file: File | Blob }) => void;
}

const FileInputMenu: React.FC<IUInputMenuProps> = (props) => {
  const { heading, className, isLoading, text, onSubmit } = props;
  const formMethods = useForm();
  useEffect(() => {
    if (formMethods.formState.errors.file) {
      setTimeout(() => {
        formMethods.reset();
      }, 5000);
    }
  }, [formMethods.formState.errors.file]);

  const onSubmitHandler = (data: any, close: any) => {
    onSubmit(data);
    close();
    formMethods.reset();
  };
  return (
    <Popover as="div" className="relative">
      <PopoverButton className="outline-none">
        <ButtonDummy
          icon={<ArrowUpTrayIcon className="size-4" />}
          text={text}
          className={`border border-extraLightGray rounded-lg h-10 ${className}`}
        />
      </PopoverButton>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <PopoverPanel className="absolute z-50 right-0 mt-2">
          {({ close }) => (
            <FormProvider {...formMethods}>
              <form
                onSubmit={formMethods.handleSubmit((data) =>
                  onSubmitHandler(data, close)
                )}
                className="w-64 flex flex-col gap-2 px-0.5 bg-white dark:bg-darkGray border
             border-lightGray dark:border-darkGray rounded-md shadow"
              >
                <h3 className="text-sm font-semibold border-b p-2 pb-1 border-lightGray dark:border-gray/70">
                  {heading}
                </h3>
                <section className="relative p-2 flex flex-col gap-2">
                  <FileInputBase
                    name="file"
                    placeholder="Upload File..."
                    accept=".csv, .xlsx, .xls"
                    selectedFile={formMethods.watch()?.file || {}}
                    registerOptions={{
                      required: `This field is Require`,
                      validate: (value) =>
                        fileUtility.validateFileType(
                          ["csv", "xlsx", "xls"],
                          value
                        ),
                    }}
                  />
                  <ButtonBase
                    isLoading={isLoading}
                    text="Submit"
                    className="h-8"
                    type="submit"
                  />
                </section>
              </form>
            </FormProvider>
          )}
        </PopoverPanel>
      </Transition>
    </Popover>
  );
};

export default FileInputMenu;
